import { render, staticRenderFns } from "./Train.vue?vue&type=template&id=451611b3&"
import script from "./Train.vue?vue&type=script&lang=js&"
export * from "./Train.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports